import { StripeProducts } from '@racemap/sdk/schema/billing/StripeProducts';
import { BillableItemTypes } from '@racemap/sdk/schema/user';
import { FrontendBillableItemTypes } from 'src/store/events/FrontendBillableItemTypes';

export function getLabelForBillingItemType(
  billingItemType: BillableItemTypes | StripeProducts | FrontendBillableItemTypes,
): string {
  switch (billingItemType) {
    case BillableItemTypes.BASE_PRICE:
    case StripeProducts.BASE_PRICE:
      return 'Base price';
    case FrontendBillableItemTypes.EVENT_CREATED:
      return 'Event created';
    case BillableItemTypes.SAFEMAP_BASE_PRICE:
    case StripeProducts.SAFEMAP_BASE_PRICE:
      return 'Safemaps';
    case BillableItemTypes.EVENT_CYCLE:
    case StripeProducts.MAP:
      return 'Maps';
    case StripeProducts.SAFEMAP:
      return 'Safemaps';
    case BillableItemTypes.KEY:
    case StripeProducts.KEY:
      return 'Used Keys';
    case BillableItemTypes.SPONSOR:
    case StripeProducts.SPONSOR_ADDON:
      return 'Add-On: Sponsor';
    case BillableItemTypes.TIMING:
    case StripeProducts.TIMING_ADDON:
      return 'Add-On: Leaderboard';
    case BillableItemTypes.MONITOR:
    case StripeProducts.MONITOR_ADDON:
      return 'Add-On: Monitor'; // TODO: remove later, kept for backward compatibility
    case BillableItemTypes.DATA_FEED:
    case StripeProducts.API_ADDON:
      return 'Add-On: Data API';
    case BillableItemTypes.HIGH_RESOLUTION:
    case StripeProducts.HIGH_RESOLUTION_ADDON:
      return 'Add-On: High Resolution';
    case BillableItemTypes.DATA_USAGE_ZONE_1:
    case BillableItemTypes.DATA_USAGE_ZONE_1_V6_SIM:
    case StripeProducts.DATA_USAGE_ZONE_1:
      return 'Data usage zone 1';
    case BillableItemTypes.DATA_USAGE_ZONE_2:
    case StripeProducts.DATA_USAGE_ZONE_2:
      return 'Data usage zone 2';
    case BillableItemTypes.DATA_USAGE_ZONE_3:
    case StripeProducts.DATA_USAGE_ZONE_3:
      return 'Data usage zone 3';
    case StripeProducts.DATA_USAGE:
      return 'Data usage';
    case BillableItemTypes.SIM_CARD:
    case StripeProducts.SIM_CARD_ACTIVATION:
      return 'Subscription: SIM card';
    case BillableItemTypes.APP:
    case StripeProducts.CUSTOM_APP:
      return 'App';
    case StripeProducts.TRACKER_MANAGEMENT:
    case BillableItemTypes.TRACKER_MANAGEMENT:
      return 'Tracker Management';
    case StripeProducts.TRACKER_RENTAL:
      return 'Tracker Rental';
    case StripeProducts.GPS_DEVICE:
    case BillableItemTypes.GPS_DEVICE:
      return 'GPS Device';
    case StripeProducts.TRANSPONDER:
    case BillableItemTypes.TRANSPONDER:
      return 'Transponder';
    case StripeProducts.MAP_OR_MONITOR_LOAD:
      return 'Map and Monitor Loads';
    case StripeProducts.API_OR_LEADERBOARD_LOAD:
      return 'API and Leaderboard Loads';

    case BillableItemTypes.STARTER:
    case StripeProducts.STARTER:
      return 'Devices (Legacy)';
    case BillableItemTypes.PAGE_VIEW:
    case StripeProducts.PAGE_VIEW:
      return 'Loads (Legacy)';
    case BillableItemTypes.EXTEND_EVENT:
      return 'Extend Event (Legacy)';
    case BillableItemTypes.SMS:
    case StripeProducts.SMS:
      return 'SMS';
    case BillableItemTypes.ACTIVATE_EVENT:
      return 'Activate Event';
    case BillableItemTypes.EVENT_DAY:
      return 'Event Day';

    default:
      throw new Error(`Unknown billing item type: ${billingItemType}`);
  }
}
